import {FilterConverter, resolveCalendarDayEadRange, hasNoExplicitDateFilter} from "../filter/FilterConverter";
import {FiltersStateInitializer} from "../defaultInitializer/FiltersStateInitializer";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {isINRegion, logOperationalMetric} from "../../util/CommonUtils";
import {getFeatureStatus, convertToValidPackageState} from "../CommonUtils";
import {FEATURES} from "../constants/CommonConstants";
import { DWELL_FILTER_ACTIONS } from "../constants/CommonConstants";


const metricProcessName = "SCC_PACKAGE_SEARCH";

// Drilldown origins that inherit the originating view's calendar-day default range, so
// the click-through list matches the bounded tile count it was opened from. Config-driven
// (add an entry to extend to a new view) rather than branching per route.
//
// Origin is detected from the URL route marker, NOT from a passed-in view: the drilldown
// layer is reached via a route component (PackageSearchData) that already derives its
// context from the URL, and viewModel.prevView is not populated on this path. Each entry
// pairs the route marker with the required leg to disambiguate (e.g. Ageing also uses
// REVERSE but is a different route).
const CALENDAR_DAY_DRILLDOWN_ORIGINS = [
    { routeMarker: "rtsBoard", leg: "REVERSE" },
];

function isCalendarDayDrillDownOrigin(leg) {
    const href = (typeof window !== "undefined" && window.location && window.location.href) ? window.location.href : "";
    // Compare leg case-insensitively: the RTS tile serializes the drilldown URL with
    // leg "Reverse" (title case, RTSDataUI) which PackageSearchData re-emits upper-cased
    // ("REVERSE"), while other callers may pass either casing. Normalize both sides so
    // the origin match does not silently break if an upstream casing changes.
    const normalizedLeg = typeof leg === "string" ? leg.toUpperCase() : leg;
    return CALENDAR_DAY_DRILLDOWN_ORIGINS.some(
        origin => origin.leg.toUpperCase() === normalizedLeg && href.indexOf(origin.routeMarker) !== -1
    );
}

// Mutates the FilterConverter output (array of [TermFilter, RangeFilter]) to add the
// EAD calendar-day range, mirroring what the RTS_VIEW metric tile applies.
function applyCalendarDayRangeToRequest(modifiedRequest, filter) {
    const rangeFilter = Array.isArray(modifiedRequest)
        ? modifiedRequest.find(f => f && typeof f.__type === "string" && f.__type.startsWith("RangeFilter"))
        : null;
    if (rangeFilter && rangeFilter.filterMap) {
        rangeFilter.filterMap["EAD"] = resolveCalendarDayEadRange(filter);
    }
}

export async function getPackageResults(filters, stationCode, view, leg, dispatcher,isCPTFilterEnabled, filterDispatcher, size) {

    var initializedFilters = FiltersStateInitializer(filters, [])
    var packageStatusMap = {}
    const modifiedRequest = await FilterConverter(initializedFilters, null, leg, packageStatusMap, null, filters.packageStatuses? filters.packageStatuses:  [], isCPTFilterEnabled);

    // Keep the drilldown list bounded to the same calendar day as the tile count it was
    // opened from. Scoped to a configured origin + no explicit date filter + flag on.
    if (isCalendarDayDrillDownOrigin(leg) && hasNoExplicitDateFilter(initializedFilters)) {
        const isCalendarDayDefaultEnabled = await getFeatureStatus(FEATURES.IS_RTS_CALENDAR_DAY_DEFAULT_ENABLED);
        if (isCalendarDayDefaultEnabled) {
            applyCalendarDayRangeToRequest(modifiedRequest, initializedFilters);
        }
    }

    var lastUpdatedRange;
    const startTime = Date.now();
    var buyBackVisibilityEnabled = isINRegion() && await getFeatureStatus(FEATURES.IS_BUYBACK_VISIBILITY_FOR_AGEINGTAB_ENABLED);
    if (initializedFilters.lastUpdatedStart !== "" || initializedFilters.lastUpdatedEnd !== "") {
        lastUpdatedRange = {
            "startTime" : initializedFilters.lastUpdatedStart ? new Date(initializedFilters.lastUpdatedStart).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedEnd).getTime() - 24 * 60 * 60 * 1000) / 1000 ,
            "endTime": initializedFilters.lastUpdatedEnd ? new Date(initializedFilters.lastUpdatedEnd).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedStart).getTime() + 24 * 60 * 60 * 1000) / 1000
        }  
    } 
    const startingIndex = 0;
    const requestBody = (size === undefined || size === "") ? 
        {
            "nodeId": stationCode,
            "packageStatusMap" : packageStatusMap,
            "filters": modifiedRequest,
            "lastUpdatedRange" : lastUpdatedRange,
        } :
        {
            "nodeId": stationCode,
            "packageStatusMap" : packageStatusMap,
            "filters": modifiedRequest,
            "lastUpdatedRange" : lastUpdatedRange,
            "size": size,
            "startingIndex": startingIndex
        }

    const request = {

        resourcePath: "/os/getDrillDownData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    const handleFilterDispatch = (packageResultList) => {
        if (filterDispatcher) {
            filterDispatcher({type: DWELL_FILTER_ACTIONS.RECEIVE_FILTER_DATA, data: { packageResultList }});
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_STATUS_TILE, selectedPackageStatusListTile: filters.packageStatuses || []});
        }
    };

    getAPIGatewayDataFromParent(request).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getDrillDownData", true);
            dispatcher({type: "RECEIVED_DATA", data: {
                isLoading: false,
                packageResultList: convertToValidPackageState(result.data.packageResultList),
                addressFieldsEnabled: result.data.addressFieldsEnabled,
                buyBackVisibilityEnabled: buyBackVisibilityEnabled
            }});
            handleFilterDispatch(result.data.packageResultList);
        } else {
            logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
            dispatcher({type: "RECEIVED_DATA", data: {
                isLoading: false,
                packageResultList: []
            }});
            handleFilterDispatch([]);
        }
    }).catch(() => {
        dispatcher({type: "RECEIVED_DATA", data: {
            isLoading: false,
            packageResultList: []
        }});
        handleFilterDispatch([]);
    });
}


// WEBPACK FOOTER //
// ./src/commons/api/GetDrillDownResults.js